import numeral from 'numeral';

numeral.register('locale', 'KZT', {
  delimiters: {
    thousands: ' ',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'тыс.',
    million: 'млн.',
    billion: 'млрд.',
    trillion: 'трлн.'
  },
  ordinal: function () {
    return '';
  },
  currency: {
    symbol: '₸'
  }
});
